import DuviriArtifact from "./includes/duviri-artifact";
import { DuviriParallax } from "./includes/duviri-parallax";

function initVideoDialog() {
    let trigger, modal, modalVideo;
    trigger = document.querySelector( "[ data-dialog='#gameplay-dialog' ]" );
    modal = document.querySelector( "#gameplay-dialog" );
    modalVideo = modal.querySelector( "video" );

    trigger.addEventListener( "click", ( event ) => {
        event.preventDefault();
        modal.showModal();
        setTimeout( () => {
            modalVideo.play();
        }, 300 );
    } );

    modal.addEventListener( "close", ( event ) => {
        modalVideo.pause();
    } );

    modal.querySelector( "[ data-dialog-close ]" ).addEventListener( "click", ( event ) => {
        event.preventDefault();
        if ( modal.open ) {
            modalVideo.pause();
            modal.close();
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    DuviriArtifact.init();
    DuviriParallax.init();
    initVideoDialog();
});

const marketBundle = document.getElementById('kullervo-marketbundle');
if (marketBundle){
    marketBundle.addEventListener('click', () => {
        dataLayer.push({
            'event': 'kullervo_marketbundle_ctr',
            'experiment_id': 'tYA_HlarTz2RsGPAZETczg',
            'variant_id': 'tYA_HlarTz2RsGPAZETczg.1'
        });
    });
}
